import {
    put,
    call,
    takeLatest,
} from 'redux-saga/effects';

import AuthUtil from '../../AuthUtil';
import { LOAN } from '../../../components/global/Server/endpoints';
import { hideError, showErrorMessage } from '../../actions/global';
import { SERVER_FAILED_ERROR_MESSAGE } from '../../../pages/Dashboard/constants';
import {
    LIST_CUSTOMER_LOAN,
    LIST_EMPLOYEE_LOAN,
    LIST_ZELLE_LOAN,
    SAVE_CUSTOMER_LOAN,
    SAVE_EMPLOYEE_LOAN, SAVE_ZELLE_LOAN
} from '../../constants/loan';
import {storeCustomerLoan, storeEmployeeLoan, storeZelleLoan} from '../../actions/loan';


function* listCustomerLoanSaga(action) {
    try {
        const response = yield call(() => AuthUtil.postRequest(LOAN.LIST_CUSTOMER_LOAN,action.data))
         if (response.status === 200 && response.data.success) {
            yield put(storeCustomerLoan(response.data.loanHistory))
         }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}


function* saveCustomerLoanSaga(action) {
    yield put(hideError())
    try {

        const response = yield call(() => AuthUtil.postRequest(LOAN.SAVE_CUSTOMER_LOAN, action.data))

        if (response.status === 200 && response.data.success) {
            if (action.callback && typeof action.callback === 'function') {
                action.callback(null, response.data.message);
            }
        } else {
            if (action.callback && typeof action.callback === 'function') {
                action.callback('error', response.data.message);
            }
            yield put(showErrorMessage(response.data.message))
        }


    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listEmployeeLoanSaga(action) {
    try {
        const response = yield call(() => AuthUtil.postRequest(LOAN.LIST_EMPLOYEE_LOAN,action.data))
         if (response.status === 200 && response.data.success) {
            yield put(storeEmployeeLoan(response.data.shortHistory))
         }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* saveEmployeeLoanSaga(action) {
    yield put(hideError())
    try {

        const response = yield call(() => AuthUtil.postRequest(LOAN.SAVE_EMPLOYEE_LOAN, action.data))

        if (response.status === 200 && response.data.success) {
            if (action.callback && typeof action.callback === 'function') {
                action.callback(null, response.data.message);
            }
        } else {
            if (action.callback && typeof action.callback === 'function') {
                action.callback('error', response.data.message);
            }
            yield put(showErrorMessage(response.data.message))
        }


    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

//Zelle

function* listZelleLoanSaga(action) {
    try {
        const response = yield call(() => AuthUtil.postRequest(LOAN.LIST_ZELLE_LOAN,action.data))
        if (response.status === 200 && response.data.success) {
            yield put(storeZelleLoan(response.data.zelleHistory,response.data.totalBalance,response.data.tableData))
        }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* saveZelleLoanSaga(action) {
    yield put(hideError())
    try {

        const response = yield call(() => AuthUtil.postRequest(LOAN.SAVE_ZELLE_LOAN, action.data))

        if (response.status === 200 && response.data.success) {
            if (action.callback && typeof action.callback === 'function') {
                action.callback(null, response.data.message);
            }
        } else {
            if (action.callback && typeof action.callback === 'function') {
                action.callback('error', response.data.message);
            }
            yield put(showErrorMessage(response.data.message))
        }


    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* loanSagas() {
    yield takeLatest(LIST_CUSTOMER_LOAN, listCustomerLoanSaga)
    yield takeLatest(SAVE_CUSTOMER_LOAN, saveCustomerLoanSaga)

    yield takeLatest(LIST_EMPLOYEE_LOAN, listEmployeeLoanSaga)
    yield takeLatest(SAVE_EMPLOYEE_LOAN, saveEmployeeLoanSaga)

    yield takeLatest(LIST_ZELLE_LOAN, listZelleLoanSaga)
    yield takeLatest(SAVE_ZELLE_LOAN, saveZelleLoanSaga)
}

